import { c as _c } from "react/compiler-runtime";
import { PaymentProcessorEnum, Tooltip, copyTextToClipboard, getPaymentProcessorTitle, toast } from '@systemeio/ui';
import { Integration } from 'modules/profile/payment-gateways/components/integration';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { flutterwaveDisconnect } from 'modules/profile/payment-gateways/integrations/flutterwave/api';
import FlutterwaveCreateModal from 'modules/profile/payment-gateways/integrations/flutterwave/components/flutterwave-create-modal';
import { flutterwaveWebhookUrl } from 'modules/profile/payment-gateways/integrations/flutterwave/constants';
import { FlutterwavePaymentIntegrationInterface } from 'modules/profile/payment-gateways/integrations/flutterwave/types';
import { getFlutterwaveHelpPageLink } from 'modules/profile/payment-gateways/integrations/flutterwave/utils';
import React, { FC, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { BinIcon, CopyIcon, FlutterwaveLogoIcon } from '@systemeio/ui/icons';
export const Flutterwave: FC = () => {
  const $ = _c(17);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    getConnectedPaymentIntegration,
    removePaymentIntegration
  } = useConnectedPaymentIntegrations();
  const [deleteOpened, setDeleteOpened] = useState(false);
  let t0;
  if ($[0] !== getConnectedPaymentIntegration) {
    t0 = getConnectedPaymentIntegration({
      processor: PaymentProcessorEnum.Flutterwave
    });
    $[0] = getConnectedPaymentIntegration;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const flutterwaveIntegration = t0;
  let t1;
  if ($[2] !== deleteOpened || $[3] !== flutterwaveIntegration || $[4] !== removePaymentIntegration || $[5] !== t || $[6] !== user?.dashboardLocale) {
    const title = getPaymentProcessorTitle(PaymentProcessorEnum.Flutterwave);
    const onDelete = async () => {
      await flutterwaveDisconnect();
      await removePaymentIntegration({
        processor: PaymentProcessorEnum.Flutterwave
      });
      toast.success(t("dashboard.settings.payment-gateways.account_removed", {
        payment: title
      }));
    };
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <FlutterwaveLogoIcon />;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    const t3 = user?.dashboardLocale;
    let t4;
    if ($[9] !== t3) {
      t4 = getFlutterwaveHelpPageLink(t3);
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        integration: getPaymentProcessorTitle(PaymentProcessorEnum.Flutterwave)
      };
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    let t6;
    if ($[12] !== t) {
      t6 = <TransLoco t={t} i18nKey="dashboard.settings.payment_gateways.help_article_label" values={t5} />;
      $[12] = t;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] !== t4 || $[15] !== t6) {
      t7 = <a className="primary-link" href={t4} target="_blank" rel="noreferrer">{t6}</a>;
      $[14] = t4;
      $[15] = t6;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    t1 = <Integration logo={t2} additionalInfo={t7}>{flutterwaveIntegration ? <div className="flex w-full justify-between gap-3 overflow-hidden"><div className="flex flex-col gap-1 truncate">{!flutterwaveIntegration.readyToUse && <p className="flex gap-1">{t("dashboard.settings.payment-gateways.integration_in_progress")}</p>}<p className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.api_public_key")}:`}</span><span className="text-text-primary truncate">{flutterwaveIntegration.details.apiPublicKey}</span></p><div className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.automation_rule.webhook_url")}:`}</span><span className="text-text-primary truncate">{flutterwaveWebhookUrl}</span><Tooltip mode="hover" label={t("global.copy")}><button onClick={async () => {
                flutterwaveWebhookUrl && (await copyTextToClipboard(flutterwaveWebhookUrl, t("global.copy_clipboard")));
              }} className="group outline-hidden"><CopyIcon className="group-focus-visible:fill-brand-primary hover:fill-brand-primary h-[16px] w-[16px] cursor-pointer" /></button></Tooltip></div><div className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.webhook_secret")}:`}</span><span className="text-text-primary truncate">{flutterwaveIntegration.details.webhookSecret}</span><Tooltip mode="hover" label={t("global.copy")}><button onClick={async () => {
                await copyTextToClipboard(flutterwaveIntegration.details.webhookSecret || "", t("global.copy_clipboard"));
              }} className="group outline-hidden"><CopyIcon className="group-focus-visible:fill-brand-primary hover:fill-brand-primary h-[16px] w-[16px] cursor-pointer" /></button></Tooltip></div><div className="w-full truncate"><TransLoco t={t} i18nKey="dashboard.settings.payment-gateways.flutterwave_configure_webhook" components={{
              a: <span className="primary-link" />
            }} /></div><div className="w-full truncate"><TransLoco t={t} i18nKey="dashboard.settings.payment-gateways.flutterwave_activate_refund" components={{
              a: <span className="primary-link" />
            }} /></div></div><Tooltip mode="hover" label={t("dashboard.settings.payment-gateways.remove_integration", {
          payment: title
        })} wrapperClassName="flex items-center" className="h-fit"><button className="group outline-hidden" onClick={() => setDeleteOpened(true)}><BinIcon className="group-focus-visible:fill-danger hover:fill-danger main-transition-colors h-[16px] w-[16px]" /></button></Tooltip><ConfirmationModal title={t("dashboard.settings.payment-gateways.remove_integration_description", {
          payment: title
        })} confirmationText={t("dashboard.settings.payment-gateways.remove_payment_text.flutterwave")} opened={deleteOpened} onClose={() => setDeleteOpened(false)} onConfirm={onDelete} /></div> : <FlutterwaveCreateModal />}</Integration>;
    $[2] = deleteOpened;
    $[3] = flutterwaveIntegration;
    $[4] = removePaymentIntegration;
    $[5] = t;
    $[6] = user?.dashboardLocale;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};